
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesGiftVoucherGrid extends Serenity.EntityGrid<POSSalesGiftVoucherRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesGiftVoucher'; }
        protected getDialogType() { return POSSalesGiftVoucherDialog; }
        protected getIdProperty() { return POSSalesGiftVoucherRow.idProperty; }
        protected getInsertPermission() { return POSSalesGiftVoucherRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesGiftVoucherRow.localTextPrefix; }
        protected getService() { return POSSalesGiftVoucherService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}